import {createContext} from 'preact';
import type {ComponentChildren} from 'preact';
import {JSX} from 'preact/jsx-runtime';

import {UiLineType} from './types';

export type UILineWrapper = (
  type: UiLineType,
  children: ComponentChildren | JSX.Element,
) => ComponentChildren | JSX.Element;

export interface LayoutContextInterface {
  lineWrapper: UILineWrapper;
  onSlotAdded: (name: string, slotContent: ComponentChildren) => void;
}

export const LayoutContext = createContext<LayoutContextInterface>({
  lineWrapper: (_, children) => children,
  onSlotAdded: () => undefined,
});
